(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.grouppractice');
    module.controller('WaitingRoomOverviewController', [
        'GroupPracticeService', 
        'ItemTableService',
        'SharedAgendaService',
        '$uibModal',
        'HelperService',
        WaitingRoomOverviewControllerFn]);

    /* controlle for email-overview */
    function WaitingRoomOverviewControllerFn(
        GroupPracticeService,
        ItemTableService,
        SharedAgendaService,
        $uibModal,
        HelperService) {

        var vm = this;
        
        vm.waitingRooms = [];        
        
        activate();
        
        function activate() {
            vm.groupPracticeId = SharedAgendaService.currentUser().groupPracticeId;
            if (!vm.groupPracticeId) {                
                return;
            }
            
            loadWaitingRooms();
        }

        function loadWaitingRooms() {
            GroupPracticeService.getWaitingRooms(vm.groupPracticeId)
                .then(function(waitingRooms) {
                    vm.waitingRooms = waitingRooms;

                    var itemTableService = ItemTableService.Instance();
                    itemTableService.init(vm.waitingRooms);
                    vm.overview = itemTableService;
                });
        }

        vm.new = function() {
            var newWaitingRoom = {
                id: 0,
                name: '',
                description: '',
                groupPracticeId: vm.groupPracticeId
            };
            showEditModal(newWaitingRoom);

        }

        vm.edit = function(waitingRoom) {
            showEditModal(waitingRoom);
        }

        vm.delete = function(waitingRoom) {
            var confirmationModal = HelperService.deactivatingConfirmationModal();
            confirmationModal.result.then(function() {
                return GroupPracticeService.deleteWaitingRoom(waitingRoom.groupPracticeId, waitingRoom.id)
                                    .then(function() {
                                       loadWaitingRooms();
                                    });
            });
        }

        function showEditModal(waitingRoom) {           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/grouppractice/waitingroom/waitingroom-detail.html',
                controller: 'WaitingRoomDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    waitingRoom: ['GroupPracticeService', function (GroupPracticeService) {
                        if (waitingRoom.id <= 0) {
                            return waitingRoom;
                        }
                        
                        return GroupPracticeService
                                    .getWaitingRoom(vm.groupPracticeId, waitingRoom.id)
                                    .then(function (room) {                            
                            return room;
                        });
                    }]
                }
            });

            // modal is closed
            modalInstance.result.then(function (item) {
                return loadWaitingRooms();
            });
        }        
    }
})();
